/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

/*!
 * @license
 * Copyright (c) 2016-2021, Udo Schöfer http://www.udos86.de
 *
 * MyProfile Dynamic Forms is based on https://github.com/udos86/ng-dynamic-forms
 *
 * Permission to use, copy, modify, and/or distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
 * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
 * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
 * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
 * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
 * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */

import { CommonModule } from '@angular/common'
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { TranslatePipe } from '@ngx-translate/core'
import { PorscheDesignSystemModule } from '@porsche-design-system/components-angular'
import { DynamicFormControlContainerComponent } from './component/dynamic-form-control-container.component'
import { DynamicFormGroupComponent } from './component/dynamic-form-group.component'
import { DynamicFormComponent } from './component/dynamic-form.component'
import { BaseFormControlComponent } from './component/form-controls/base-form-control.component'
import { DynamicBasicCheckboxComponent } from './component/form-controls/checkbox/dynamic-basic-checkbox.component'
import { DynamicBasicInputComponent } from './component/form-controls/input/dynamic-basic-input.component'
import { PasswordStrengthMeterModule } from './component/form-controls/input/password-strength-meter/password-strength-meter.module'
import { DynamicBasicParagraphComponent } from './component/form-controls/paragraph/dynamic-basic-paragraph.component'
import { DynamicBasicRadioGroupComponent } from './component/form-controls/radio-group/dynamic-basic-radio-group.component'
import { DynamicBasicSelectComponent } from './component/form-controls/select/dynamic-basic-select.component'
import { DynamicListDirective } from './directive/dynamic-list.directive'
import { AutoFocusDirective } from './directive/auto-focus.directive'

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, TranslatePipe, PasswordStrengthMeterModule, PorscheDesignSystemModule],
  declarations: [
    BaseFormControlComponent,
    DynamicListDirective,
    AutoFocusDirective,
    DynamicFormGroupComponent,
    DynamicFormComponent,
    DynamicFormControlContainerComponent,
    DynamicBasicCheckboxComponent,
    DynamicBasicInputComponent,
    DynamicBasicRadioGroupComponent,
    DynamicBasicSelectComponent,
    DynamicBasicParagraphComponent,
  ],
  exports: [DynamicFormComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DynamicFormsCoreModule {}
